export const initBackgroundChange = () => {
  const navigation: HTMLElement | null = document.querySelector(
    '.js-navigation[data-transparent="true"]'
  );

  if (!navigation) {
    return;
  }

  const updateNavigationBackground = () => {
    if (window.scrollY > 0) {
      navigation.style.backgroundColor = 'var(--color-black-1000)';
      return;
    }

    navigation.style.backgroundColor = 'transparent';
  };

  updateNavigationBackground();

  window.addEventListener('scroll', updateNavigationBackground, {
    passive: true,
  });
};
